import { Box, BoxProps, Thead as CThead } from '@chakra-ui/react';
import React, { forwardRef } from 'react';

export const Thead = forwardRef(({ children, ...props }: BoxProps, ref) => (
  <CThead
    ref={ref}
    as={Box}
    sx={{
      display: 'table-header-group',
      h: 12,
      ...props?.sx,
    }}
  >
    {children}
  </CThead>
));
